import { SET_FEATURE_ACCESS } from 'redux/actionTypes';

export function setFeatureAccess(payload) {
	return {
		type: SET_FEATURE_ACCESS,
		payload,
	};
}
